import { z } from "zod";
import { CLAVES } from "../sat/catalogos.js";
import { ESTADOS_PROYECTO } from "./estados.js";
const monto = z
    .string()
    .regex(/^\d+(\.\d{1,2})?$/, "monto inválido")
    .optional();
export const proyectoCreateSchema = z.object({
    clienteId: z.uuid(),
    nombre: z.string().trim().min(1).max(200),
    clave: z
        .string()
        .trim()
        .toUpperCase()
        .max(30)
        .optional()
        .describe("Clave corta para referenciar el proyecto, p.ej. ACME-ERP"),
    descripcion: z.string().max(4000).optional(),
    estado: z.enum(ESTADOS_PROYECTO).default("PROPUESTA"),
    moneda: z.enum(CLAVES.moneda).default("MXN"),
    montoEstimado: monto,
    fechaInicio: z.iso.date().optional(),
    fechaFinEstimada: z.iso.date().optional(),
    fechaFinReal: z.iso.date().optional(),
});
export const proyectoUpdateSchema = proyectoCreateSchema
    .partial()
    .omit({ clienteId: true });
export const listaProyectosQuerySchema = z.object({
    clienteId: z.uuid().optional(),
    estado: z.enum(ESTADOS_PROYECTO).optional(),
    q: z.string().trim().optional(),
    limite: z.coerce.number().int().min(1).max(200).default(50),
    cursor: z.string().optional(),
});
//# sourceMappingURL=proyecto.js.map